import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useContext } from 'react';
import { View } from 'react-native';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils';
import { DynamicSvg } from '../dynamic-svg';
import { Typography } from '../typography';
import { getNotifierProps, getNotifierStyles } from './NotifierStyles';
export var Notifier = forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e;
  var stateContext = useContext(StateConfigContext);
  var notifierProps = getNotifierProps(props, stateContext);
  var notifierStyles = getNotifierStyles(notifierProps);
  var _notifierProps$number = notifierProps.number,
    number = _notifierProps$number === void 0 ? 0 : _notifierProps$number,
    style = notifierProps.style,
    iconName = notifierProps.iconName,
    hasDot = notifierProps.hasDot,
    config = notifierProps.config,
    _notifierProps$state = notifierProps.state,
    state = _notifierProps$state === void 0 ? 'default' : _notifierProps$state,
    _notifierProps$testID = notifierProps.testID,
    testID = _notifierProps$testID === void 0 ? 'Notifier' : _notifierProps$testID,
    size = notifierProps.size;
  var color = (_b = (_a = config === null || config === void 0 ? void 0 : config.controlState) === null || _a === void 0 ? void 0 : _a[state]) === null || _b === void 0 ? void 0 : _b.color;
  var numberValue = (_c = Math.floor(Math.min(Math.max(number, 0), 9))) === null || _c === void 0 ? void 0 : _c.toString();
  var iconSize = (_e = (_d = config === null || config === void 0 ? void 0 : config.size) === null || _d === void 0 ? void 0 : _d[size]) === null || _e === void 0 ? void 0 : _e.notifierIconSize;
  return _jsx(View, Object.assign({
    ref: ref,
    style: [notifierStyles.container, style]
  }, getTestId(testID), {
    children: !hasDot && _jsx(_Fragment, {
      children: iconName ? _jsx(DynamicSvg, Object.assign({
        iconName: iconName,
        color: color,
        fontSize: iconSize
      }, getTestId(testID, 'icon'))) : _jsx(Typography, Object.assign({
        type: 'body-single-line-xxs-bold',
        text: numberValue,
        color: color
      }, getTestId(testID, 'hasDot')))
    })
  }));
});